<style lang="scss" scoped>
@import "@/styles/variables.scss";
.reset {
    background: $secondary;
    height: 100vh;
    width: 100%;
    display: flex;

    .logo {
        height: 60px;
        width: auto;
        margin-right: auto;
    }
}
</style>

<template>
    <div class="reset d-flex flex-wrap">

        <box class="mx-auto mt-auto mb-30 col-12 col-md-5 col-lg-5" :padding="90">

            <template slot="content">

                <i-logo class="logo mb-45"></i-logo>

                <form @submit.prevent="submit">

                    <p class="mb-15 fs-16">We’ll email you instructions to reset your password.</p>

                    <div v-if="error" class="fs-12 text-danger mb-30">
                        {{ error }}
                    </div>

                    <!-- Email -->
                    <div class="form-row">
                        <div class="form-group col-12">
                            <label for="email">Email address <span class="ml-auto text-danger">{{ errors.first('email') }}</span></label>
                            <input v-model="user.email" v-validate="'required|email'" name="email" type="email" class="form-control" id="email" placeholder="Email address">
                        </div>
                    </div>

                    <div class="form-row mt-15">
                        <div class="form-group col-12 mb-0">
                            <button class="btn btn-primary">Reset</button>
                        </div>
                    </div>

                </form>
            </template>

        </box>

        <div class="mx-auto mb-auto col-12 text-center text-white">
            Return to
            <router-link class="text-white" :to="{ name: 'login' }">Log in</router-link>.
        </div>

    </div>
</template>


<script>
import { mapActions } from "vuex";

export default {
    data() {
        return {
            user: {
                email: ""
            },
            error: ""
        };
    },
    methods: {
        ...mapActions(["resetPassword"]),
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    this.resetPassword(this.user.email)
                        .then(() => {
                            this.$toasted.show("Er werd een e-mail met instructies om uw wachtwoord te wijzigen verzonden");
                            this.$router.push("/login");
                        })
                        .catch(error => {
                            this.error = error.response.data.error_description;
                        });
                }
            });
        }
    }
};
</script>
